"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @Desc
 * @Author leon <leondwong@gmail.com>
 * @Date 1/30/18
 */
exports.default = {
    ORIGINAL_URL_LOST: 'originalUrl is lost',
    SHOULD_NO_SCHEMA_IN_ORIGINAL_URL: 'originalUrl should not include schema like http or https etc...',
    PROTOCOL_UNDEFINED: 'Protocol undefined, if current env is your local machine, ignore this. if not, please contact sso administrator',
    CONFIG_USING_LOCAL_ACCESS_POINT: "Can't get accessPoint from remote config, using local config",
    SYS_ERROR: 'system error, plz contact sso manager',
    STATE_ERROR: 'state not found or a pair of states is not matched(the cause maybe is csrf attack)',
};
//# sourceMappingURL=en_GB.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/locale/en_GB.js